import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { ModuleFeature } from './module-feature.model';

export class ModuleFeatureStateModel extends EntityStateModel<ModuleFeature> {}
